export enum STORE_ACTION_TYPES {
  SET_IS_AUDIO_ENABLED = 1,
  SET_IS_MUSIC_ENABLED = 2,
}
